import prop from 'lodash/fp/prop';

export default (state = [], action = {}) => {
  switch (action.type) {
    case 'RANKINGS_SET':
      return action.payload;
    case 'RANKINGS_ADD':
      return [...state, action.payload];
    case 'RANKING_DETAILS_SET':
      return state.map(
        ranking =>
          ranking._id === action.payload._id
            ? {
                ...ranking,
                name: action.payload.name,
                participants: action.payload.participants.map(prop('_id'))
              }
            : ranking
      );
    case 'RANKING_DETAILS_REMOVED':
      return state.filter(({ _id }) => action.meta._id !== _id);
    default:
      return state;
  }
};
